module.exports = {
  width: 1000,
  height: 700,
  margin: 40,
  theme: require('./theme'),
  print: require('@jimpick/spectacle/themes/default/print'),
  html: require('@jimpick/spectacle/themes/default/html')
};



// WEBPACK FOOTER //
// ./programs/epsHybridIntermediates/config.js